import { createDarkFamilyComponents } from '../dark-family/create-components'

export const createComponents = ({ palette }) =>
    createDarkFamilyComponents({
        palette,
        tweaks: {
            appBarAlpha: 0.86,
            paperAlpha: 0.92,
            elevatedSurfaceAlpha: 0.92,
            tableHeadAlpha: 0.08,
            borderAlpha: 0.14,
            hoverBorderAlpha: 0.24
        }
    })
